import { Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import Container from "@saleor/components/Container";
import { useTemplateStyles } from "@saleor/dropOff/styles/templates";
import { MallListDropOff_malls_edges_node } from "@saleor/dropOff/types/MallListDropOff";
import { sectionNames } from "@saleor/intl";
import { ListProps } from "@saleor/types";
import * as React from "react";
import { useIntl } from "react-intl";

import DropOffTemplatesTable from "./DropOffTemplatesTable";

interface DropOffActiveMallsProps extends ListProps {
  dropOffList: MallListDropOff_malls_edges_node[];
}

const DropOffActiveMalls: React.FC<DropOffActiveMallsProps> = props => {
  const { dropOffList } = props;

  const classes = useTemplateStyles(props);
  const intl = useIntl();

  return (
    <Container>
      <div className={classes.headerSection}>
        <div className={classes.headerLeft}>
          <div className={classes.headerTitleMall}>
            <h5 className={classes.headerTitle}>
              {intl.formatMessage(sectionNames.dropOffManagement)}
            </h5>
            <Typography color="primary" className={classes.mallTitle}>
              {"Active Malls"}
            </Typography>
          </div>
        </div>
      </div>

      <Card className={classes.dropOffCard}>
        <DropOffTemplatesTable dropOffList={dropOffList} {...props} />
      </Card>
    </Container>
  );
};

export default DropOffActiveMalls;
